import React from 'react';
import PropTypes from 'prop-types';

import Button from '../../../../global/Button';
import Angle from '../../../../global/Angle';

const propTypes = {
  onDelete: PropTypes.func,
  onMoveLeft: PropTypes.func,
  onMoveRight: PropTypes.func,
  disabled: PropTypes.bool,
};

const AlbumSlideshowThumbnailControls = ({
  onDelete,
  onMoveLeft,
  onMoveRight,
  disabled,
}) => {
  return (
    <div className="slideshow-grid-viewer-thumbnail-controls">
      {onDelete && (
        <Button
          btnStyle="reset"
          onClick={onDelete}
          disabled={disabled}
          className="slideshow-grid-viewer-thumbnail-control-btn delete-btn"
        >
          &times;
        </Button>
      )}
      {onMoveLeft && (
        <Button
          btnStyle="reset"
          onClick={onMoveLeft}
          disabled={disabled}
          className="slideshow-grid-viewer-thumbnail-control-btn left-btn"
        >
          <Angle direction="left" />
        </Button>
      )}
      {onMoveRight && (
        <Button
          btnStyle="reset"
          onClick={onMoveRight}
          disabled={disabled}
          className="slideshow-grid-viewer-thumbnail-control-btn right-btn"
        >
          <Angle direction="right" />
        </Button>
      )}
    </div>
  );
};

AlbumSlideshowThumbnailControls.propTypes = propTypes;

export default AlbumSlideshowThumbnailControls;
